import { api } from "@/api/api";
import { GenerationStatusResponse } from "@/api/images-types";
import { useQuery } from "@tanstack/react-query";

export function useGenerationStatus(generationId: string | null, { enabled } = { enabled: true }) {
  return useQuery<GenerationStatusResponse>({
    queryKey: ["generationStatus", generationId],
    queryFn: () => api.images.checkGenerationStatus.generationId.get({ generationId: generationId! }),
    enabled: generationId !== null && enabled,
  });
}
